import {
  ArrayItem,
  OperatorWalletType,
  IAccountListItem,
  AccountOperator
} from '@/api/schema';
import { capitalization } from '@/helpers/formatString';

export const Status = {
  declined: 'DECLINED',
  on: 'ON',
  off: 'OFF',
  created: 'CREATED'
};

// TODO: fix - crutch for not showing operator payments feature on prod, feature flags not prepared yet
export const enableOperatorPayments = ['.stage.', '.dev.', 'localhost'].some(
  (str) => location.hostname.toLowerCase().includes(str)
);

export const OperatorWalletTypesArray: ArrayItem[] = Object.values(
  Object(OperatorWalletType)
).map((v) => {
  const str = String(v);
  return {
    value: str,
    text: str
      .split('_')
      .map((v) => capitalization(v))
      .join(' ')
  };
});

export const formatBrandName = (value: string): string => {
  const domainRegex = /^(?:https?:\/\/)?(?:www\.)?([^\/.]+)/i;
  const match = value?.match(domainRegex);

  return match ? match[1] : '';
};

export const groupOperatorsByBrandName = (
  list: AccountOperator[],
  divider: boolean = false
): { [key: string]: AccountOperator } => {
  return list.reduce(
    (acc, operator) => ({
      ...acc,
      [capitalization(operator.brandName || 'Other')]: [
        ...(acc[capitalization(operator.brandName || 'Other')] ||
          (divider ? [{ divider: true }] : [])),
        {
          ...operator,
          name: capitalization(operator.name)
        }
      ]
    }),
    {}
  );
};

export const groupOperatorsByAccounts = (
  list: AccountOperator[]
): IAccountListItem[] => {
  return Object.entries(groupOperatorsByBrandName(list)).map(
    ([key, value]) => ({
      name: capitalization(key),
      children: value
    })
  );
};
